"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PictorialIconDisplay = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const _1 = require("./");
const PictorialIconDisplay = ({ icons }) => {
    const [searchQuery, setSearchQuery] = react_1.default.useState("");
    const iconKeys = icons.filter((icon) => icon.toLowerCase().includes(searchQuery.toLowerCase()));
    return (react_1.default.createElement(__1.Box, { sx: { color: "text01" } },
        react_1.default.createElement("input", { type: "text", placeholder: "Search Pictorial Icons...", value: searchQuery, onChange: (e) => setSearchQuery(e.target.value), style: { margin: "10px 0px 20px", padding: "10px", width: "100%" } }),
        react_1.default.createElement(__1.Box, { style: {
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                gap: "20px"
            } }, iconKeys.map((iconKey) => (react_1.default.createElement(__1.Box, { key: iconKey, style: {
                border: "1px solid #dcdcdc",
                borderRadius: "4px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px"
            } },
            react_1.default.createElement(_1.PictorialIcon, { icon: iconKey }),
            react_1.default.createElement("span", { style: {
                    marginTop: "5px",
                    textAlign: "center",
                    fontSize: "14px"
                } }, iconKey)))))));
};
exports.PictorialIconDisplay = PictorialIconDisplay;
//# sourceMappingURL=PictorialIconDisplay.js.map